module.exports = __webpack_public_path__ + "img/Millionaire-3.e35b7ad0.png";